import { MutationCache, QueryCache, QueryClient } from '@tanstack/react-query';
import { apiErrorBus, ApiClientError } from './errors';

/**
 * One QueryClient for the app. Retry policy: never retry a 4xx (auth, not_found, rate_limited
 * and friends will not fix themselves); retry a dropped connection or a 5xx once.
 * Every failure is also reported on the apiErrorBus so the SessionProvider can send the
 * visitor to the session-expired, login or maintenance screen from any query.
 */
export function createQueryClient(overrides: { retry?: boolean } = {}): QueryClient {
  return new QueryClient({
    queryCache: new QueryCache({ onError: (e) => apiErrorBus.emit(e) }),
    mutationCache: new MutationCache({ onError: (e) => apiErrorBus.emit(e) }),
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        refetchOnWindowFocus: false,
        retry: (count, error) => {
          if (overrides.retry === false) return false;
          if (error instanceof ApiClientError) return (error.code === 'network' || error.status >= 500) && error.status !== 503 && count < 1;
          return count < 1;
        },
      },
    },
  });
}
